import { ActionFunctionArgs, redirect } from "react-router-dom";
import { AuthError } from "@/types/errorTypes/authError";
import { apiEndpoints } from "@/services/api/api.ts";
import { AdminPanelUserData } from "@/routes/adminPanel/users/main/types/adminPanelUserData.ts";
import {RoleEnum} from "@/types/auth/roleEnum.ts";

export const adminPanelUserEditAction = async ({ request }: ActionFunctionArgs) => {
    const formData = await request.formData();

    const parsedData = Object.fromEntries(formData) as unknown as AdminPanelUserData;

    const roles = formData.getAll("roles") as string[];
    const userData = {
        ...parsedData,
        roles: roles.map((role: string) => parseInt(role) as RoleEnum) || []
    } as AdminPanelUserData;

    const url = new URL(request.url);
    const returnUrl = url.searchParams.get('returnUrl') || '/admin-panel/users';

    try {
        const userUpdateResult = await apiEndpoints.updateUser(userData);
        if (userUpdateResult) {
            return redirect(returnUrl);
        }
        return {
            formError: "Güncelleme işlemi başarısız oldu."
        };
    } catch (err) {
        const error = err as AuthError;
        const errorMessage = error.message || "Güncelleme sırasında bir hata oluştu";
        console.error(errorMessage);
        return {
            formError: "Kullanıcı güncellenirken bir hata oluştu. Lütfen tekrar deneyin."
        };
    }
};